<template>
  <!-- Filtrado de la tabla -->
  <div class="filtro-tabla" v-if="filtro">
    <b-row class="carga-archivos filtro">
      <b-col cols="12" align-self="center">
        <b-row>
          <b-col sm="12" md="12" lg="2">
            <h3>Filtrado</h3>
          </b-col>
          <b-col sm="12" md="12" lg="10">
            <b-row>
              <b-col sm="12" md="6" lg="3" v-if="showFilterDates">
                <b-form-group label="Desde:" label-for="desde">
                  <datepicker
                    v-model="fecha_i"
                    :language="es"
                    bootstrap-styling
                    :format="customFormatter"
                    name="desde"
                  ></datepicker>
                </b-form-group>
              </b-col>

              <b-col sm="12" md="6" lg="3" v-if="showFilterDates">
                <b-form-group label="Hasta:" label-for="hasta">
                  <datepicker
                    v-model="fecha_f"
                    :language="es"
                    bootstrap-styling
                    :format="customFormatter"
                    name="hasta"
                  ></datepicker>
                </b-form-group>
              </b-col>

              <b-col sm="12" md="6" lg="3" v-if="showSelectFiltro">
                <b-form-group label="Seleccione:" label-for="seleccione">
                  <SelectComponet
                    v-model="filter_Selected"
                    :data="SetectFiltro"
                    name="seleccione"
                  ></SelectComponet>
                </b-form-group>
              </b-col>

              <b-col sm="12" md="6" lg="3" v-if="showFilterConvenios">
                <b-form-group label="Codigo:" label-for="convenios">
                  <SelectComponet
                    v-model="filterConvenios"
                    :data="Convenios"
                    id="convenios"
                    :disabled="loading_helper"
                  ></SelectComponet>
                </b-form-group>
              </b-col>

              <b-col sm="12" md="6" lg="3" v-if="showFilterEstadoGarantia">
                <b-form-group label="Estados:" label-for="estadosGarangia">
                  <SelectComponet
                    v-model="filter_EstadoGarantiaSelected"
                    :data="EstadoGarantia"
                    id="estadosGarangia"
                  ></SelectComponet>
                </b-form-group>
              </b-col>

              <b-col sm="12" md="6" lg="3" v-if="showFilterCedula">
                <b-form-group label="Cédula" label-for="cedula">
                  <b-form-input
                  id="cedula"
                  type="text"
                  v-model="filterCedula"
                  @change="$emit('update:cedula', filterCedula)"
                  placeholder="Cédula"
                ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col sm="12" md="6" lg="3" v-if="showFilterPagare">
                <b-form-group label="Pagaré" label-for="pagare">
                  <b-form-input
                    id="pagare"
                    type="text"
                    v-model="filterPagare"
                    @change="$emit('update:pagare', filterPagare)"
                    placeholder="Pagaré"
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col sm="12" md="6" lg="3" v-if="showFilterCaseNumber">
                <b-form-group label="Numero del caso" label-for="case_number">
                  <b-form-input
                    id="case_number"
                    type="number"
                    v-model="filterCase_number"
                    @change="$emit('update:case_number', filterCase_number)"
                    placeholder="Ej: 5444872"
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col sm="12" md="6" lg="3" v-if="showFilterCaseName">
                <b-form-group label="Nombre del caso" label-for="case_name">
                  <b-form-input
                    id="case_name"
                    type="text"
                    v-model="filterNombre"
                    @change="$emit('update:nombre', filterNombre)"
                    placeholder="Ej: Petición Actualización"
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col sm="12" md="6" lg="3" v-if="showFilterModelos">
                <b-form-group label="Modelo:" label-for="Modelos">
                  <SelectComponet
                    v-model="filter_ModelosSelected"
                    :data="Modelos"
                    id="Modelos"
                  ></SelectComponet>
                </b-form-group>
              </b-col>

              <b-col sm="12" md="6" lg="3" v-if="showFilterTipoDoc">
                <b-form-group label="Tipo de archivo:" label-for="Tipo de archivo">
                  <SelectComponet
                    v-model="filter_TipoArchivoSelected"
                    :data="TipoArchivo"
                    id="TipoArchivo"
                  ></SelectComponet>
                </b-form-group>
              </b-col>

              <b-col sm="12" md="6" lg="3" v-if="pagination">
                <b-form-group
                  label="Registros por pagina:"
                  label-for="inputGroupSelect01"
                >
                  <select
                    class="custom-select"
                    id="inputGroupSelect01"
                    v-model="nRows"
                    @change="setPages(nRows)"
                  >
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </b-form-group>
              </b-col>

              <b-col sm="2" offset="10">
                <div class="filtro-button text-right">
                  <b-button
                    variant="primary"
                    @click="clickBorrar()"
                    size="sm"
                    class="btn-filtro"
                  >Borrar</b-button
                  >
                  <b-button v-if="showButtonBuscar"
                    variant="primary"
                    @click="$emit('buscar')"
                    size="sm"
                    class="btn-filtro"
                    :disabled="loading"
                  >Buscar</b-button
                  >
                  <b-button v-if="showButtonGenerar"
                    variant="success"
                    @click="$emit('generar')"
                    size="sm"
                    class="btn-filtro"
                    :disabled="loading"
                    >Generar</b-button
                  >
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import SelectComponet from "@/components/form/Select.vue";

export default {
  name: "FilterTable",
  data() {
    return {
      // dateInicio: this.$moment()
      //   .startOf("month")
      //   .format("YYYY-MM-DD 00:00:00"),
      // dateFin: this.$moment().format("YYYY-MM-DD 23:59:59"),
      // filterSelected: null,
      // filterCedula: null,
      // filterPagare: null,
      // filterCaseNumber: null,
      // filterCaseName: null,
      // filterEstadoGarantiaSelected: null,
      // filterConvenioSelected: null,
      // nRows: null,
      es: es,
      selected: null,
      pages: [],
      fecha_i: this.$moment().startOf("month").format("YYYY-MM-DD 00:00:00"),
      fecha_f: this.$moment().format("YYYY-MM-DD 23:59:59"),
      filter_Selected: null,
      filterCedula: null,
      filterPagare: null,
      filterCase_number: null,
      filterNombre: null,
      filterConvenios: null,
      filter_EstadoGarantiaSelected: null,
      nRows: null,
      filter_ModelosSelected:null,
      filter_TipoArchivoSelected:null,
    };
  },
  props: {
    SetectFiltro: {
      default: () => [],
      type: Array,
      required: false,
    },
    showButtonBuscar: {
      default: () => true,
      type: Boolean,
    },
    showButtonGenerar: {
      default: () => false,
      type: Boolean,
    },
    EstadoGarantia: {
      default: () => [],
      type: Array,
      required: false,
    },
    Modelos: {
      default: () => [],
      type: Array,
      required: false
    },
    TipoArchivo: {
      default: () => [],
      type: Array,
      required: false,
    },
    Convenios: {
      default: () => [],
      type: Array,
      required: false,
    },
    showSelectFiltro: {
      default: () => true,
      type: Boolean,
    },
    showFilterDates: {
      default: () => false,
      type: Boolean,
    },
    showFilterCedula: {
      default: () => false,
      type: Boolean,
    },
    showFilterPagare: {
      default: () => false,
      type: Boolean,
    },
    showFilterCaseNumber: {
      default: () => false,
      type: Boolean,
    },
    showFilterCaseName: {
      default: () => false,
      type: Boolean,
    },
    showFilterConvenios: {
      default: () => false,
      type: Boolean,
    },
    showFilterEstadoGarantia: {
      default: () => false,
      type: Boolean,
    },
    showFilterModelos: {
      default: () => false,
      type: Boolean
    },
    showFilterTipoDoc: {
      default: () => false,
      type: Boolean,
    },
    filtro: {
      default: () => false,
      type: Boolean,
    },
    pagination: {
      default: () => false,
      type: Boolean,
    },
    dataLength: {
      type: Number,
      required: true,
    },
    perPage: {
      default: () => null,
    },
    fecha_inicio: {
      type: String,
    },
    fecha_fin: {
      type: String,
    },
    filterSelected: {
      type: String,
    },
    cedula: {
      type: String,
    },
    pagare: {
      type: String,
    },
    case_number: {
      type: String,
    },
    nombre: {
      type: String,
    },
    convenio: {
      type: Number,
    },
    filterEstadoGarantiaSelected: {
      type: String,
    },
    filterModelosSelected: {
      type: String
    },
    filterTipoArchivoSelected: {
      type: String
    }
  },
  components: {
    SelectComponet,
    Datepicker,
  },
  computed: {
    loading() {
      return this.$store.getters.loading;
    },
    loading_helper() {
      return this.$store.getters.loading_helper;
    },
  },
  methods: {
    customFormatter(date) {
      return this.$moment(date).format("YYYY-MM-DD");
    },
    clickBorrar() {
        (this.fecha_i = this.$moment().startOf("month").format("YYYY-MM-DD 00:00:00")),
        (this.fecha_f = this.$moment().format("YYYY-MM-DD 23:59:59")),
        (this.filter_Selected = null),
        (this.filterCedula = null),
        (this.filterPagare = null),
        (this.filterCase_number = null),
        (this.filterCase_number = null),
        (this.filterConvenios = null),
        (this.filter_ModelosSelected = null),
        (this.filter_TipoArchivoSelected = null),
        (this.filter_EstadoGarantiaSelected = null),
      this.$emit("borrar",
      {
        fecha_inicio : this.fecha_i,
        fecha_fin: this.fecha_f
      })
    },

    setPages(nRows) {
      this.$emit("set-pages", nRows, true);
      this.$emit('update:nRows', nRows)
    }
  },
  watch: {
    selected: value => {},
    fecha_i(newVal){
      this.$emit('update:fecha_inicio', this.$moment(newVal).format('YYYY-MM-DD 00:00:00'))
    },
    fecha_f(newVal){
      this.$emit('update:fecha_fin', this.$moment(newVal).format('YYYY-MM-DD 00:00:00'))
    },
    filter_Selected(newVal){
      this.$emit('update:filterSelected', newVal)
    },
    filter_EstadoGarantiaSelected(newVal){
      this.$emit('update:filterEstadoGarantiaSelected', newVal)
    },
    filterConvenios(newVal){
      this.$emit('update:convenio', newVal)
    },
    filter_ModelosSelected(newVal){
      this.$emit('update:filterModelosSelected', newVal)
    },
    filter_TipoArchivoSelected(newVal){
      this.$emit('update:filterTipoArchivoSelected', newVal)
    }

  },
  mounted() {
    this.nRows = this.perPage;
    this.$emit('update:fecha_inicio', this.fecha_i)
    this.$emit('update:fecha_fin', this.fecha_f)
  }
};
</script>
